import { initializeApp, getApps, FirebaseApp } from 'firebase/app'
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check'
import { environment } from '../../environments/environment'

export function getFirebaseApp(): FirebaseApp | null {

  if (getApps().length > 0) return getApps()[0]

  const app = initializeApp(environment.firebase!)

  // App Check (reCAPTCHA Enterprise): attaches a bot-protection token to
  // Firebase calls. Skipped when no site key is configured (staging today -
  // see environment.ts). Initialized right after the app, before any
  // auth/firestore/storage getter runs, so tokens attach to their requests.
  if (environment.appCheckSiteKey) {
    try {
      initializeAppCheck(app, {
        provider: new ReCaptchaEnterpriseProvider(environment.appCheckSiteKey),
        isTokenAutoRefreshEnabled: true,
      })
    } catch (error) {
      console.warn('App Check initialization failed:', error)
    }
  }

  return app
}
